import styled from 'styled-components';

const ResultsLabel = styled.span`
  font-family: 'Avenir Light', 'Arial', sans-serif;
`;

export default ResultsLabel;
